
import { defineComponent } from "vue";
import { XrplClient, Call } from "xrpl-client";
import { utils } from "xrpl-txdata";

export default defineComponent({
  name: "AccountAndCurrencyPicker",
  data() {
    return {
      loading: false,
      error: "",
      account: "",
      accountName: "",
      lookedUpAccount: null,
      currencies: {},
      selectedCurrency: "XRP",
      amount: "",
    };
  },
  props: {
    accountTypeLabel: String,
    xrpl: XrplClient,
    ready: Function,
    step: String,
  },
  computed: {
    isDestination() {
      return this.accountTypeLabel?.match(/destination/i);
    },
  },
  watch: {
    account() {
      this.lookedUpAccount = null;
      this.accountName = "";
      this.selectedCurrency = "XRP";
      this.currencies = {};
      this.amount = "";

      if (this.ready) {
        this.ready(false);
      }
    },
    lookedUpAccount() {
      if (!this.isDestination && this.ready && this.lookedUpAccount) {
        this.ready(
          this.lookedUpAccount === this.account ? this.lookedUpAccount : false
        );
      }
    },
    selectedCurrency() {
      this.handleReadyDestination();
    },
    amount() {
      this.handleReadyDestination();
    },
  },
  mounted() {
    if (process.env.NODE_ENV === "development") {
      this.account = !this.accountTypeLabel?.match(/destination/i)
        ? "rwietsevLFg8XSmG3bEZzFein1g8RBqWDZ"
        : "rpePPeRpC89vpCY3CDzhzMCs78nPoNnAKm";
    }
  },
  methods: {
    handleReadyDestination() {
      if (!isNaN(Number(this.amount)) && this.ready) {
        this.ready(
          Number(this.amount) > 0
            ? this.lookedUpAccount +
                "|" +
                this.selectedCurrency +
                "|" +
                String(this.amount)
            : false
        );
      }
    },
    async call(command: Call) {
      this.loading = true;
      this.error = "";

      const results = await this.xrpl?.send(command);

      this.loading = false;

      if (results?.error) {
        this.error = (results.error + " " + results?.error_message).trim();
      }

      return results;
    },
    async go() {
      // console.log(this.account, this.accountTypeLabel);
      this.accountName = "";

      const results = await this.call({
        command: "account_currencies",
        account: this.account,
      });

      console.log({ results });

      this.currencies = [
        { code: "XRP", label: "XRP (native asset)" },
        ...(results?.receive_currencies || []).map((code: string) => {
          return {
            code,
            label: utils.currencyCodeFormat(code),
          };
        }),
      ];

      if (this.ready && !this.loading && this.error === "") {
        this.loading = true;

        this.accountName = "Loading account name...";
        const accountInfoCall = await fetch(
          "https://xumm.app/api/v1/platform/account-meta/" + this.account
        );
        const accountInfo = await accountInfoCall.json();
        this.lookedUpAccount = accountInfo?.account;
        this.accountName =
          accountInfo?.xummProfile?.accountAlias ||
          accountInfo?.thirdPartyProfiles?.[0]?.accountAlias;

        this.loading = false;
      }

      this.$nextTick(() => {
        window.scrollTo(0, document.body.scrollHeight);
      });
    },
  },
});
